import type { KnowledgeArticle } from '../types/knowledge-base.type';
import { getKnowledgeArticleTranslations } from '../locales/help/articles';
import { helpI18n, isHelpRtl } from '../i18n/help';

export function localizeKnowledgeArticle(article: KnowledgeArticle): KnowledgeArticle {
  const translation = getKnowledgeArticleTranslations(helpI18n.language)?.[article.id];
  if (!translation) return article;

  return {
    ...article,
    title: translation.title,
    summary: translation.summary ?? article.summary,
    content: translation.content,
  };
}

export function localizeKnowledgeArticles(articles: KnowledgeArticle[]): KnowledgeArticle[] {
  return articles.map(localizeKnowledgeArticle);
}

export function knowledgeArticleMatchesSearch(
  article: KnowledgeArticle,
  query: string
): boolean {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return true;

  const localized = localizeKnowledgeArticle(article);
  const translations = getKnowledgeArticleTranslations(helpI18n.language);

  const searchableText = [
    article.title,
    article.summary,
    article.content,
    localized.title,
    localized.summary,
    localized.content,
    translations?.[article.id]?.title,
    translations?.[article.id]?.content,
    ...article.tags,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  return searchableText.includes(normalizedQuery);
}

export function getHelpTextDirection(): 'rtl' | 'ltr' {
  return isHelpRtl(helpI18n.language) ? 'rtl' : 'ltr';
}
